import { inject } from 'vue'

export function useDownloadFile() {
  const axios = inject('$axios')

  const downloadFile = (file) => {
    axios.get(file.url, { responseType: 'blob' }).then((response) => {
      const blob = new Blob([response.data], { type: file.mime_type })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = file.file_name
      link.click()
      URL.revokeObjectURL(link.href)
      link.remove()
    })
  }

  return { downloadFile }
}
